import { OTHER_VALUE } from "./FieldState";

export default (value: string | string[] | null | undefined) =>
  Array.isArray(value) ? value.includes(OTHER_VALUE) : value === OTHER_VALUE;
